import { gql } from 'apollo-boost';

export const SEARCH_COORDINATORS = gql`
  query COORDINATORS {
    coordinators {
      total
      page
      docs {
        id
        firstName
        lastName
        avatar
      }
    }
  }
`;

export const COORDINATOR = gql`
  query COORDINATOR($id: ID) {
    coordinator(id: $id) {
      id
      firstName
      lastName
      email
      phone
      bio
      avatar
    }
  }
`;

export const UPDATE_COORDINATOR = gql`
  mutation UPDATE_COORDINATOR($id: ID, $input: CoordinatorInput) {
    updateCoordinator(id: $id, input: $input) {
      id
    }
  }
`;

export const ADD_COORDINATOR = gql`
  mutation ADD_COORDINATOR($input: CoordinatorInput) {
    addCoordinator(input: $input) {
      id
    }
  }
`;
